import { useForm } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Counterparty } from "@/types";
import { Checkbox } from "@/components/ui/checkbox";

type Props = {
  counterparty?: Counterparty;
};

export function CounterpartyForm({ counterparty }: Props) {
  const { data, setData, post, patch, processing, errors, transform } = useForm(
    {
      name: counterparty?.name ?? "",
      auto_reconcile: counterparty?.auto_reconcile ?? false,
      vat_rate: counterparty?.vat_rate ?? 0,
    },
  );

  transform((data) => {
    return { counterparty: data };
  });

  function handleSubmit(e: React.SyntheticEvent<HTMLFormElement>) {
    e.preventDefault();

    if (counterparty) {
      patch(`/counterparties/${counterparty.id}`, {
        preserveScroll: "errors",
      });
    } else {
      post("/counterparties", {
        preserveScroll: "errors",
      });
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="counterparty_name">Name</Label>
        <Input
          id="counterparty_name"
          name="name"
          value={data.name}
          onChange={(e) => setData("name", e.target.value)}
          aria-invalid={!!errors.name}
        />
        {errors.name && (
          <p className="text-destructive text-sm">{errors.name}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="counterparty_auto_reconcile">Auto reconcile</Label>
        <Checkbox
          id="counterparty_auto_reconcile"
          checked={data.auto_reconcile}
          onCheckedChange={(checked) =>
            setData("auto_reconcile", Boolean(checked))
          }
        />
        {errors.auto_reconcile && (
          <p className="text-destructive text-sm">{errors.auto_reconcile}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label htmlFor="counterparty_vat_rate">VAT rate</Label>
        <Input
          id="counterparty_vat_rate"
          name="vat_rate"
          value={data.vat_rate}
          type="number"
          onChange={(e) => setData("vat_rate", parseInt(e.target.value))}
          aria-invalid={!!errors.vat_rate}
        />
        {errors.vat_rate && (
          <p className="text-destructive text-sm">{errors.vat_rate}</p>
        )}
      </div>
      <div className="flex justify-end">
        <Button type="submit" disabled={processing}>
          {counterparty ? "Update counterparty" : "Create counterparty"}
        </Button>
      </div>
    </form>
  );
}
